import { openModal } from './showModal'
import { pickElementAll } from './utils'

export function showModalForClientButtons() {
  const buttonsVariant1 = pickElementAll('[id^="cta_landing_formulario_"]')
  const buttonsVariant2 = pickElementAll('[id^="cta_web_formulario"]')

  function showModal(buttons) {
    buttons.forEach((btn) => {
      btn.removeAttribute('href')
      openModal(btn)
    })
  }

  showModal(buttonsVariant1)
  showModal(buttonsVariant2)
}
